<template>
  <div>
    <h4 style="width: 40%;margin: 20px auto;font-weight: 600">机构专属小程序登录二维码</h4>
    <div style="display: flex;justify-content: center">
      <div style="background: #e0a800;margin: 0 80px;width: 150px;height: 150px;">
        <el-image style="width: 100%;height: 100%;" :src="this.bank_filename" :lazy="true" />
        <div style="margin-top: 10px;font-weight: 600">银行管理端</div>
        <div style="border-radius: 5px;background: #159ad4;color: #FFFFFF" @click="bank_deposit3">保存到本地</div>
      </div>
      <div style="background: #6f42c1;margin: 0 80px;width: 150px;height: 150px;">
        <el-image style="width: 100%;height: 100%;" :src="this.shop_filename" :lazy="true" />
        <div style="margin-top: 10px;font-weight: 600">商家端</div>
        <div style="border-radius: 5px;background: #159ad4;color: #FFFFFF" @click="shop_deposit2">保存到本地</div>
      </div>
<!--      <div style="background: #5daf34;margin: 0 80px;width: 150px;height: 150px;">-->
<!--        <el-image style="width: 100%;height: 100%;" :src="this.user_filename" :lazy="true" />-->
<!--        <div style="margin-top: 10px;font-weight: 600">客户领券端</div>-->
<!--        <div style="border-radius: 5px;background: #159ad4;color: #FFFFFF" @click="user_deposit1">保存到本地</div>-->
<!--      </div>-->
    </div>
    <div style="margin: 80px auto 0px;width:610px">银行管理人员、新商家可通过扫码完成首次体验，再次进入时可通过微信小程序栏进入</div>
    <div style="margin: 10px auto;width:610px;padding-left:4.5px">机构：单一网点、县/区支行管理部门、市行管理部门、省行管理部门均计为独立的机构，各自有各自的银行管理端小程序登录二维码、商家端小程序登录二维码。</div>
  </div>
</template>

<script>

export default {
  name: "Select",
  data() {
    return {
      img_id3: [],
      bank_filename: '',//银行二维码
      img_id2: [],
      user_filename: '',//用户二维码
      img_id1: [],
      shop_filename: '',//商家二维码
      bank_code:'',
      bank_name:'',
    }
  },
  created() {
    this.shop_code_select()
    this.bank_code_select()
    this.user_code_select()
  },
  methods: {
    // 查询银行二维码
    bank_code_select() {
      let that = this;
      let _jsondata_ = {
        perPageSize: 100,
        currentPage: 1,
        obj_bank_center_id: that.customGlobal.userInfoExt.cui_bank_center_id,
        obj_province_id: that.customGlobal.userInfoExt.cui_province_id,
        company_id: that.customGlobal.userInfoExt.company_id,
        obj_city_id: that.customGlobal.userInfoExt.cui_city_id,
        obj_county_id: that.customGlobal.userInfoExt.cui_county_id,
        obj_station_id: that.customGlobal.userInfoExt.cui_station_id,
        bdbi_type: '3',
        bdbi_status: '1',
        bdbi_device_id: '',
        bdbi_qr_type: '3'
      };
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var s4 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManager_Advertisement_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      s4.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.img_id3 = [];
          that.img_id3 = res.data.rows;
          if (that.img_id3.length > 0) {
            that.bank_filename = that.img_id3[0].bdbi_path;
          }
          console.info("银行图片" + this.bank_filename);
        } else {
          console.info("银行二维码查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '银行二维码查询出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '银行二维码查询出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    // 查询用户二维码
    user_code_select() {
      let that = this;
      let _jsondata_ = {
        perPageSize: 100,
        currentPage: 1,
        obj_bank_center_id: that.customGlobal.userInfoExt.cui_bank_center_id,
        obj_province_id: that.customGlobal.userInfoExt.cui_province_id,
        obj_city_id: that.customGlobal.userInfoExt.cui_city_id,
        obj_county_id: that.customGlobal.userInfoExt.cui_county_id,
        company_id: that.customGlobal.userInfoExt.company_id,
        obj_station_id: that.customGlobal.userInfoExt.cui_station_id,
        bdbi_type: '3',
        bdbi_status: '1',
        bdbi_device_id: '',
        bdbi_qr_type: '2'
      };
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var s4 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManager_Advertisement_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      s4.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.img_id2 = [];
          that.img_id2 = res.data.rows;
          if (that.img_id2.length > 0) {
            that.user_filename = that.img_id2[0].bdbi_path;
          }
          console.info("用户图片" + this.user_filename);
        } else {
          console.info("用户二维码查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '用户二维码查询出错!', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '用户二维码查询出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    // 查询商家二维码
    shop_code_select() {
      let that = this;
      let _jsondata_ = {
        perPageSize: 100,
        currentPage: 1,
        obj_bank_center_id: that.customGlobal.userInfoExt.cui_bank_center_id,
        obj_province_id: that.customGlobal.userInfoExt.cui_province_id,
        obj_city_id: that.customGlobal.userInfoExt.cui_city_id,
        obj_county_id: that.customGlobal.userInfoExt.cui_county_id,
        company_id: that.customGlobal.userInfoExt.company_id,
        obj_station_id: that.customGlobal.userInfoExt.cui_station_id,
        bdbi_type: '3',
        bdbi_status: '1',
        bdbi_device_id: '',
        bdbi_qr_type: '1'
      };
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        target: '.main',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
      var s4 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManager_Advertisement_select,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      s4.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.img_id1 = [];
          that.img_id1 = res.data.rows;
          if (that.img_id1.length > 0) {
            that.shop_filename = that.img_id1[0].bdbi_path;
          }
        } else {
          console.info("商家二维码查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        this.$alert(JSON.stringify(error.message), '商家二维码查询出错!', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        this.$alert(JSON.stringify(res.message), '商家二维码查询出错', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      });
    },
    //银行保存按钮
    bank_deposit3() {
      this.bank_code = this.bank_filename;
      console.log(this.bank_code)
      this.bank_name = 'bank';
      this.downs();
    },//商家保存按钮
    shop_deposit2() {
      this.bank_code = this.shop_filename;
      console.log(this.bank_code)
      this.bank_name = 'shop';
      this.downs();
    },//客户保存按钮
    user_deposit1() {
      this.bank_code = this.user_filename;
      console.log(this.bank_code)
      this.bank_name = 'user';
      this.downs();
    },
    //同源图片下载
    downs1() {
      var alink = document.createElement("a");
      alink.href = this.bank_code;
      alink.download = this.bank_name; //图片名
      alink.click();
    },
    //不同源图片下载
    downloadIamge(bank_code, name) {//下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = bank_code;
    },
    downs() {
      this.downloadIamge(this.bank_code, this.bank_name)
    },
  }
}
</script>

<style scoped>
.box-select {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/views/components/QRCode.vue